import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AnalyticsService } from './analytics.service';
import { Guid, Utility } from '../core/common';
import { AbTestService } from './ab-test.service';

const DEFAULT_TIMEOUT = 60; // 1 minute
@Injectable({
	providedIn: 'root'
})
export class CommunicationEventService {
	actions = {
		karpasha: {
			supervision: {
				viewVerifyJobTitles: { Category: 'karpasha', Action: 'view-verify-jobtitles', Label: 'supervision' },
				getSeekersByJobTitle: { Category: 'karpasha', Action: 'get-seekers-by-jobtitle', Label: 'supervision' },
				verifySeekerJobTitle: { Category: 'karpasha', Action: 'verify-seeker-jobtitle', Label: 'supervision' },
			},
			signup: {
				viewForm: { Category: 'karpasha', Action: 'view-form', Label: 'signup' },
				login: { Category: 'karpasha', Action: 'login', Label: 'signup' },
				showLogin: { Category: 'karpasha', Action: 'show-login', Label: 'signup' },
				preAgreed: { Category: 'karpasha', Action: 'pre-agreed', Label: 'signup' },
				agreed: { Category: 'karpasha', Action: 'agreed', Label: 'signup' },
				disAgreed: { Category: 'karpasha', Action: 'dis-agreed', Label: 'signup' },
				paid: { Category: 'karpasha', Action: 'paid', Label: 'signup' },
				startPayment: { Category: 'karpasha', Action: 'start-payment', Label: 'signup' },
				sentToIPG: { Category: 'karpasha', Action: 'sent-to-ipg', Label: 'signup' },

				// showStep: { Category: 'karpasha', Action: 'show-step', Label: 'signup' },

			},
			bridge: {
				openJobMatrix: { Category: 'karpasha', Action: 'open-job-matrix', Label: 'bridge' },

			},
			seeker: {
				viewPipeline: { Category: 'karpasha', Action: 'view-pipeline', Label: 'seeker' },
				searchJob: { Category: 'karpasha', Action: 'search-job', Label: 'seeker' },
				// selectJob: { Category: 'karpasha', Action: 'select-job', Label: 'seeker' },
				// moveJob: { Category: 'karpasha', Action: 'move-job', Label: 'seeker' },
				// removeJob: { Category: 'karpasha', Action: 'remove-job', Label: 'seeker' },
			},
			job: {
				viewPipeline: { Category: 'karpasha', Action: 'view-pipeline', Label: 'job' },
				searchSeeker: { Category: 'karpasha', Action: 'search-seeker', Label: 'job' },
				// selectSeeker: { Category: 'karpasha', Action: 'select-seeker', Label: 'job' },
				// moveSeeker: { Category: 'karpasha', Action: 'move-seeker', Label: 'job' },
				// removeSeeker: { Category: 'karpasha', Action: 'remove-seeker', Label: 'job' },
			},
		},
		vanguard: {
			seeker: {
				viewPackages: { Category: 'vanguard', Action: 'view-packages', Label: 'seeker' },
				startPayment: { Category: 'vanguard', Action: 'start-payment', Label: 'seeker' },
				sentToIPG: { Category: 'vanguard', Action: 'sent-to-ipg', Label: 'seeker' },
				paid: { Category: 'vanguard', Action: 'paid', Label: 'seeker' },
			}
		},
		resume: {
			seeker: {
				becameAcceptable: { Category: 'resume', Action: 'became-acceptable', Label: 'seeker' },
			}
		},
		rtwad:{
			owner: {
				//rtwad-view-form-new
				viewFormNew: { Category: 'rtwad', Action: 'view-form-new', Label: 'owner' },
				//rtwad-view-form-update
				viewFormUpdate: { Category: 'rtwad', Action: 'view-form-update', Label: 'owner' },
				//rtwad-start-payment
				startPayment: { Category: 'rtwad', Action: 'start-payment', Label: 'owner' },
				//rtwad-sent-to-ipg
				sentToIPG: { Category: 'rtwad', Action: 'sent-to-ipg', Label: 'owner' },
				//rtwad-payment-success
				paymentSuccess: { Category: 'rtwad', Action: 'payment-success', Label: 'owner' },
				//rtwad-payment-failed
				paymentFailed: { Category: 'rtwad', Action: 'payment-failed', Label: 'owner' },
			},
			viewer: {
				//rtwad-detail-view
				detailView: { Category: 'rtwad', Action: 'detail-view', Label: 'viewer' },
				//rtwad-detail-show-contact
				detailShowContact: { Category: 'rtwad', Action: 'detail-show-contact', Label: 'viewer' },
				//rtwad-detail-redirect
				detailRedirect: { Category: 'rtwad', Action: 'detail-redirect', Label: 'viewer' },
			}
		}
	}

	constructor(private http: HttpClient, private analytics: AnalyticsService, private abTest: AbTestService) {
	}

	private eventsMap: { [key: string]: EventLog } = {};
	log(...eventData: Partial<EventLog>[]) {
		let event = new EventLog(Object.assign({ Timeout: DEFAULT_TIMEOUT }, ...eventData));

		const existing = this.eventsMap[event.Key];
		if (existing?.Expired === false)
			Object.assign(event, { Id: existing.Id, StartTime: existing.StartTime, ActionCount: existing.ActionCount });

		event.ActionCount++;
		event.ActionTime = Math.round((Date.now() - event.StartTime) / 1000);
		this.eventsMap[event.Key] = event;
		this.eventLog(event);
		this.cleanup();
	}

	private eventLog(event: EventLog) {
		setTimeout(() => this.analytics.gtmEvent(event.Action, event.Category, event.Label, event.NonInteraction, event.Value), 0);
		if (event.Data && !event.Info) {
			event.Info = Object.keys(event.Data || {}).map(key => {
				let value = event.Data[key];
				if (!(typeof (value) === 'string'))
					value = JSON.stringify(value);
				return { key, value };
			});
			delete event.Data;
		}
		event.AbTests = this.abTest.getAbTests();
		event.Version = environment.app.version;

		this.http.post(environment.app.apiUrl + `chat/event-log`, event).subscribe();
	}

	private cleaning = false;
	private cleanup() {
		if (this.cleaning) return;
		this.cleaning = true;
		const now = Date.now();
		Object.keys(this.eventsMap).forEach(key => {
			const event = this.eventsMap[key];
			if (event?.Expired)
				delete this.eventsMap[key];
		});
		this.cleaning = false;
	}

}

export class EventLog {
	Id: string = Guid.newGuid();
	Category: string;
	Action: string;
	Label: string;
	RelatedItems: { Id: string, Index: string, Relation: string }[];
	Data: { [key: string]: string };
	Info: { key: string, value: string }[];
	AbTests: { key: string, value: string }[];
	NonInteraction: boolean;
	Value: number;
	Version: string;

	/// Timeout in seconds
	Timeout: number;
	StartTime: number = Date.now();
	/// Action time in seconds
	ActionTime: number = 0;
	ActionCount: number = 0;
	get Key(): string {
		return `${this.Category || ''}-${this.Action || ''}-${this.Label || ''}-${this.RelatedItems?.map(_ => _.Id).join('-') || ''}`;
	}
	get Expired(): boolean {
		return this.StartTime + (this.Timeout * 1000) < Date.now();
	}

	constructor(init?: Partial<EventLog>) {
		Object.assign(this, init);
	}
}
